// @flow
import React from 'react';
import axios from 'axios';
import toast from 'react-simple-toasts';
import { setPrejoinPageVisibility } from '../../../prejoin/actions.web';
import { CURRENT_ROOM_NAME } from '../../../webjam/constant';
import config from '../../config';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V3 } from '../../constant';
import { setOrganization } from '../../redux/tool-webjam-v2/actions';
import { setConfirmationModalProps, setInvitedUserConfirm, setInvitedUserMState, setJammingCapabilityState, setPrejoinScreenUserRoute } from '../../redux/tool-webjam-v3/actions';
import { setUserIsLogin, setUserLoginData } from '../../redux/tool-webjam/actions';
import { _startConference, calculateTimeDiff, dispatch, getBaseConfig, getQueryString, getStore, InvitedUserConfirmFlag, SOCIAL_AUTH_TOKEN } from '../../Utils';
import { getUserLanguage, verifyAuthTokenAsync, verifySocialToken } from '../../welcome-dashboard/Request.d';
import CustomTooltip from '../toolbar/CustomTooltip';
import { updateSettings } from '../../../base/settings';
import { messages } from '../../welcome-dashboard/messages';
import { ct } from '../../constant-Utils';
import i18next from 'i18next';
import PackageList from '../../welcome-dashboard/components/payment/PackageList';
import { SaveUserEmail } from './SaveUserEmail';

export async function getSocialToken() {
    // remove auth
    localStorage.removeItem("auth");
    // Get Social Token
    let myOrgId;
    let socialAuthToken = await getQueryString(SOCIAL_AUTH_TOKEN);

    if (!socialAuthToken) {
        let localSocialAuthToken = localStorage.getItem('socialAuthToken')
        if (localSocialAuthToken) {
            socialAuthToken = localSocialAuthToken
        } else {
            return false;
        }
    }

    let localAuth = ""
    localStorage.removeItem("socialAuthToken");
    localStorage.setItem("socialAuthToken", socialAuthToken);

    const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX)
    setTimeout(function () {
        let _store_v1 = getStore(FEATURE_CUSTOM_REDUX);
        if (!_store_v1.userLoginData?.user) {
            toast(ct("Translate.messages.unableToProcessAgain"));
            window.location.reload();
        }
    }, 15000)

    let getLocalAuth = localStorage.getItem("auth");
    let userPassConfirm = "";
    try {
        if (localStorage.getItem("auth")) {
            getLocalAuth = JSON.parse(getLocalAuth);
            // if (getLocalAuth.hasOwnProperty("token") && getLocalAuth.hasOwnProperty("is_invited") && getLocalAuth.hasOwnProperty("room_name")) {
            //     if (getLocalAuth.is_invited == true && getLocalAuth.room_name == window.location.pathname.substring(1)) {
            //         if (getLocalAuth.hasOwnProperty("with_jam")) {
            //             userPassConfirm = getLocalAuth.with_jam ? "with" : "without";
            //         }
            //         localAuth = getLocalAuth.token
            //     }
            // }
        }
    } catch (e) {
        console.log("getLocalAuth error => ", e)
    }

    if (localAuth == "") {
        localStorage.removeItem("auth");
    }

    // Get Organization ID
    let requestPay = {
        method: 'GET',
        url: config.socket_endpoint + "/session/organizations"
    }
    let dataOrg = await axios(requestPay);
    if (dataOrg) {
        let data = dataOrg.data.data;
        if (data.length) {
            let myDomain = window.location.origin;
            let myOrg;
            for (let i = 0; i < data.length; i++) {
                if (data[i].domain == myDomain) {
                    myOrg = data[i];
                    break;
                }
            }
            if (myOrg) {
                myOrgId = myOrg?._id
                dispatch(setOrganization(myOrg));
            } else {
                // return false;
            }
        }
    }

    // Get Room Name From Social URl
    let socialRoom = CURRENT_ROOM_NAME;
    if (socialRoom.length == 0) {
        socialRoom = ""
    }

    // check if user is guest/invited and has already detail, just verify with aut token
    try {
        if (localAuth) {
            let resp = await verifyAuthTokenAsync(localAuth);
            if (resp.status == 1) {
                dispatch(setUserIsLogin(true));
                let loginDetls = {
                    ...userLoginData,
                    user: {
                        ...getLocalAuth
                    }
                }
                if (userPassConfirm) {
                    if (userPassConfirm == "without") {
                        dispatch(setPrejoinPageVisibility(false, 6));
                        dispatch(setPrejoinScreenUserRoute(""))
                    }
                }
                dispatch(setUserLoginData(loginDetls, "token verify existing"));
                return true;
            }
        }
    } catch (e) {
        console.log("localAuth error =>", e)
    }

    // Verify Social Token
    let verifyTokenDetail = await verifySocialToken({
        accessToken: socialAuthToken,
        organization_id: myOrgId,
        roomname: socialRoom,
    })

    if (verifyTokenDetail.status == 1) {
        let tokenDetails = verifyTokenDetail.data
        localStorage.setItem("auth", JSON.stringify(tokenDetails));
        if (tokenDetails.hasOwnProperty("stripe_customer_id")) {
            delete tokenDetails.stripe_customer_id;
        }

        if (tokenDetails.hasOwnProperty("stripe_account_id")) {
            delete tokenDetails.stripe_account_id;
        }

        if (tokenDetails.hasOwnProperty("connectVerified")) {
            delete tokenDetails.connectVerified;
        }

        let socialInvite = getBaseConfig('socialInvite')
        let logUser = {
            email: tokenDetails.email,
            id: tokenDetails.id,
            username: tokenDetails.username,
            is_invited: tokenDetails.is_invited,
            rtaSocialUserId: tokenDetails.rtaSocialUserId,
            is_app: tokenDetails.is_app,
            is_jamming: tokenDetails?.is_jamming
        };

        if (logUser.is_app == true) {
            let head = document.head;
            let link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = "css/mobile-app-custom.css";
            head.appendChild(link)
        }

        if (socialInvite) {
            if (tokenDetails.hasOwnProperty("is_invited") && tokenDetails.is_invited == true && !tokenDetails.hasOwnProperty("email")) {
                logUser = {
                    is_invited: tokenDetails.is_invited,
                    is_app: tokenDetails.is_app,
                    guest_id: tokenDetails.guest_id,
                    is_jamming: tokenDetails?.is_jamming
                }

                // hide premetting and show invite register modal
                dispatch(setPrejoinPageVisibility(false, 7));
                // dispatch(setInvitedUserMState(true));
                // if(!tokenDetails?.is_jamming){
                //     dispatch(setJammingCapabilityState(true));
                // }
            } else {
                logUser = {
                    email: tokenDetails.email,
                    id: tokenDetails.id,
                    username: tokenDetails.username,
                    is_invited: tokenDetails.is_invited,
                    rtaSocialUserId: tokenDetails.rtaSocialUserId,
                    is_app: tokenDetails.is_app,
                    is_jamming: tokenDetails?.is_jamming
                }
            }
        }

        let showPrejoinScreen = false
        let is_invited = false;
        if (logUser.is_invited == true && logUser?.is_jamming == false) {
            if (userPassConfirm == "") {
                if (CURRENT_ROOM_NAME.length > 2) {
                    let { alwaysShowPreJoining } = getStore(FEATURE_CUSTOM_REDUX_V3)
                    if (alwaysShowPreJoining) {
                        is_invited = true;
                        // dispatch(setInvitedUserConfirm(InvitedUserConfirmFlag.IS_CONFIRMING));
                        dispatch(setInvitedUserMState(true))
                    }
                }
            }
        }

        let currentRoomDetail = {};
        if (CURRENT_ROOM_NAME) {
            let is_match_roomname = false;
            // jamming capability will not consider yet

            // if (tokenDetails.hasOwnProperty("jamming_capability_rooms")) {
            //     if (tokenDetails.jamming_capability_rooms.length) {
            //         currentRoomDetail = tokenDetails.jamming_capability_rooms.find(d => d.room_name == CURRENT_ROOM_NAME)
            //         if (currentRoomDetail) {
            //             is_match_roomname = true;
            //         }
            //     }
            // }
            if (!is_match_roomname) {
                tokenDetails['current_room_jamming_capability'] = {
                    room_name: CURRENT_ROOM_NAME,
                    status: 1
                }
            }
        }
        tokenDetails = { ...tokenDetails, current_room_jamming_capability: currentRoomDetail };

        if (logUser.is_invited == false && logUser.email != "") {
            if (CURRENT_ROOM_NAME.length > 2) {
                // dispatch(setPrejoinPageVisibility(false, 8));
                let willConfirm = true;
                if (tokenDetails.hasOwnProperty("current_room_jamming_capability") && tokenDetails?.current_room_jamming_capability?.status && tokenDetails?.current_room_jamming_capability?.status != 1) {
                    willConfirm = false
                    showPrejoinScreen = true
                    if (tokenDetails.current_room_jamming_capability.status == 3) {
                        dispatch(setPrejoinScreenUserRoute(InvitedUserConfirmFlag.WITHOUT_DEVICE))
                    }
                }

                let { alwaysShowPreJoining } = getStore(FEATURE_CUSTOM_REDUX_V3)
                if (!alwaysShowPreJoining) {
                    willConfirm = false;
                }

                if (willConfirm) {
                    let hasMusicRoom = sessionStorage.getItem("music_tm_" + CURRENT_ROOM_NAME);
                    if (hasMusicRoom) {
                        try {
                            if (calculateTimeDiff(hasMusicRoom, messages.musicModeTimeLimit)) {
                                willConfirm = false;
                            }
                        } catch (e) {
                            console.log("hasMusicRoom error =>", e)
                        }
                    }
                }

                sessionStorage.removeItem("music_tm_" + CURRENT_ROOM_NAME);
                if (willConfirm) {
                    if (!is_invited) {
                        dispatch(setPrejoinScreenUserRoute(InvitedUserConfirmFlag.IS_CONFIRMING))
                    }
                }
            }
        }

        let updateData = {
            ...userLoginData,
            user: {
                ...(getStore(FEATURE_CUSTOM_REDUX)?.userLoginData?.user || {}),
                ...logUser,
                phone: tokenDetails?.phone
            }
        }

        if (tokenDetails?.claimedRoom != undefined) {
            updateData = Object.assign(updateData, {
                room: tokenDetails?.claimedRoom
            })
            tokenDetails = Object.assign(tokenDetails, {
                room_name: tokenDetails?.claimedRoom?.groupName
            })
        }

        // if (!!socialRoom) {
        if (updateData.user?.id && updateData.user?.is_invited == true) {
            dispatch(setPrejoinPageVisibility(false, 9));
            dispatch(setInvitedUserMState(false));
            // if(!tokenDetails?.is_jamming){
            //     dispatch(setJammingCapabilityState(true));
            // }
        }
        const hidePreJoinScreen = getBaseConfig("hidePreJoinScreen");
        if (tokenDetails?.is_jamming) {
            if (hidePreJoinScreen && updateData?.room?.admin) {
                dispatch(setPrejoinPageVisibility(false, 10));
            } else {
                dispatch(setPrejoinPageVisibility(true, 11));
            }

        }

        if (showPrejoinScreen) {
            if (logUser.is_invited == false) {
                if (hidePreJoinScreen && updateData?.room?.admin) {
                    dispatch(setPrejoinPageVisibility(false, 12));
                } else {
                    dispatch(setPrejoinPageVisibility(true, 13));
                }
            }
        }

        // if user already completed the prejoin, if make refresh then don't show prejoin screen again
        if (calculateTimeDiff(sessionStorage.getItem("up_time_" + CURRENT_ROOM_NAME), 30)) {
            // dispatch(setPrejoinScreenUserRoute(InvitedUserConfirmFlag.DEFAULT))
            // _startConference("prejoin hide 1")
            dispatch(setPrejoinPageVisibility(false, 14));
        }

        dispatch(setUserLoginData(
            {
                ...updateData,
                jamming_capability_rooms: tokenDetails?.jamming_capability_rooms || [],
                profilePercentage: tokenDetails?.profile_percentage || 0
            }, "token verify welcome-page"))
        // }

        if (tokenDetails.hasOwnProperty("email")) {
            dispatch(setUserIsLogin(true));
        }

        if (tokenDetails.hasOwnProperty("jamming_capability_rooms")) {
            delete tokenDetails.jamming_capability_rooms
        }

        dispatch(updateSettings({
            displayName: updateData.user.username
        }, 'user-token-auth'))

        localStorage.setItem("auth", JSON.stringify(tokenDetails));

        let getUserLang = await getUserLanguage();
        if (getUserLang.status && getUserLang.data) {
            i18next.changeLanguage(getUserLang.data);
        } else {
            i18next.changeLanguage(tokenDetails?.user_lang || 'en');
        }
        return true;
    } else {
        return false;
    }
}

// handle large string with tooltip
export const concatLargeString = (content, length) => {
    if (content && content?.length > length) {
        return <div className='home-menu-list-text' style={{ position: 'relative' }}>
            <CustomTooltip className="custom-tooltip-mixer" content={content} position="bottom">
                <span className="home-menu-list-text">{content.substr(0, length) + "..."}</span>
            </CustomTooltip>
        </div>;
    }
    return content;
}

export const handleSubscription = (type = "") => {
    const noSubscriptionMsg = type === "box" ? ct("rta-trmc.dashboard.subscription.noSubscriptionMsgForPremium") : ct("rta-trmc.dashboard.subscription.noSubscriptionMsg");
    const handleDispatch = (showApplyCouponModal = false) => {
        dispatch(setConfirmationModalProps({
            isShow: true,
            rtaClassName: "invite-modal-dialog",
            testId: "user-subscription-modal",
            size: "large",
            zIndex: 999,
            title: ct("Translate.typography.subscription"),
            content: <PackageList
                showApplyCouponModal={showApplyCouponModal}
                showPremium={type === "box"}
                hideLogo={true}
                showPackageOnly={false}
                requestFrom="modal"
                closeSubscription={() => dispatch(setConfirmationModalProps({ isShow: false }))} />,
            showOkButton: false,
            cancelBtnName: ct("rta-trmc.natType.natTypeRejectedCancelBtn"),
            onCancel: () => {
                dispatch(setConfirmationModalProps({ isShow: false }));
            },
            callHideDialog: false
        }));
    }
    dispatch(setConfirmationModalProps({
        isShow: true,
        title: ct("Translate.typography.subscription"),
        content: <>{noSubscriptionMsg} <span onClick={() => {
            handleDispatch(false);
        }} className="hyperlink-text">{ct("rta-trmc.dashboard.subscription.buyNow")}</span> {ct("rta-trmc.dashboard.subscription.or")} <span onClick={() => {
            handleDispatch(true);
            }} className="hyperlink-text">{ct("rta-trmc.dashboard.subscription.enterCoupon")}.</span></>,
        showOkButton: false,
        cancelBtnName: ct("rta-trmc.natType.natTypeRejectedCancelBtn"),
        onCancel: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
        },
        callHideDialog: false
    }));
}

export const askForEmail = (type = "") => {
    /**
     * This Function will open the modal, where user can save his email address.
     * If conference is started, then can set type = conference, if not then set type= dashboard
     * because we have different modal for conference and dashboard
     */
    let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
    if (conferenceJoined) {
        dispatch(setConfirmationModalProps({
            isShow: true,
            type: "conference",
            testId: "ask-for-email",
            title: ct("rta-trmc.dialogs.email"),
            content: <SaveUserEmail />,
            successBtnName: ct("Translate.buttonTitle.submit"),
            cancelBtnName: ct("rta-trmc.natType.natTypeRejectedCancelBtn"),
            onCancel: () => {
                dispatch(setConfirmationModalProps({ isShow: false }));
            },
            callHideDialog: false,
            showOkButton: false,
            showCancelButton: false,
        }));
    } else {
        dispatch(setConfirmationModalProps({
            isShow: true,
            type: "dashboard",
            testId: "ask-for-email",
            title: ct("rta-trmc.dialogs.email"),
            showFooter: false,
            className: "coupon-code-dialog",
            content: <SaveUserEmail />,
            handleConfirmAction: (status) => {
                if (status) {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                } else {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                }
            }
        }));
    }

}